export const OPEN_ADD_BENEFICIARY_FORM_MODAL = 'OPEN_ADD_BENEFICIARY_FORM_MODAL';
export const CLOSE_ADD_BENEFICIARY_FORM_MODAL = 'CLOSE_ADD_BENEFICIARY_FORM_MODAL';
export const CHANGE_LAYER_BENEFICIARY_FORM_MODAL = 'CHANGE_LAYER_BENEFICIARY_FORM_MODAL';

function openBeneficiaryFormModal(parentW8ImyForm, addingImyLayer) {
  if (addingImyLayer !== true) {
    addingImyLayer = false;
  }

  return {
    type: OPEN_ADD_BENEFICIARY_FORM_MODAL,
    isAddBeneficiarFormModalShown: true,
    isAddingImyToExistingLayer: addingImyLayer,
    parentW8ImyForm
  };
}

function changeImyChoiceOnBeneficiaryFormModal(value) {
  return {
    type: CHANGE_LAYER_BENEFICIARY_FORM_MODAL,
    isAddingImyToExistingLayer: value,
  };
}

function closeAddBeneficiaryFormModal() {
  return {
    type: CLOSE_ADD_BENEFICIARY_FORM_MODAL,
    isAddBeneficiarFormModalShown: false,
    isAddingImyToExistingLayer: false,
    addBeneficiaryFormResponse: null,
    addBeneficiaryFormError: null
  };
}

export function showBeneficiaryFormModal(parentW8ImyForm, addingImyLayer) {
  return (dispatch) => {
    dispatch(openBeneficiaryFormModal(parentW8ImyForm, addingImyLayer));
  };
}

export function hideAddBeneficiaryFormModal() {
  return (dispatch) => {
    dispatch(closeAddBeneficiaryFormModal());
  };
}

export function changeImyBeneficiaryFormModal(value) {
  return (dispatch) => {
    dispatch(changeImyChoiceOnBeneficiaryFormModal(value));
  };
}
